import BasicInfo from './BasicInfo'

export default BasicInfo
